"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "If you listen to the health anxiety part of your thinking, how likely does that part think it is that you’ll get coronavirus?",
  type: "radio",
  options: ["Pretty likely (1 in 100 chance)", "Maybe (1 in thousand chance)", "Totally unlikely (1 in a million chance)"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "If you listen to the health anxiety part of your thinking, how likely does that part think it is that you’ll get coronavirus?"
  }
}, {
  prompt: "Are you generally healthy?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "Are you generally healthy?"
  }
}, {
  prompt: "Are you under 75 years old?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "Are you under 75 years old?"
  }
}, {
  prompt: "Have you ever had a heart or lung disease or diabetes I?",
  type: "radio",
  options: ["No, never had either of those", "Yes"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "Have you never had a heart or lung disease or diabetes I?"
  }
}, {
  prompt: "Do you have adequate access to a good healthcare system?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "Do you have adequate access to a good healthcare system?"
  }
}, {
  prompt: "Do you have people who can support you if you did get sick?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_ANXIETY_ODDS",
  meta: {
    summaryTitle: "Do you have people who can support you if you did get sick?"
  }
}, {
  prompt: "This exercise is more effective if you can think of some personal reasons why you’d be likely to cope if you did get sick. Can you write any personal reasons here?",
  type: "textarea",
  meta: {
    answerLabel: "Personal reasons why you’d be likely to cope if you did get sick",
    summaryTitle: "Personal reasons why you’d be likely to cope if you did get sick"
  },
  batteryId: "CORONA_ANXIETY_ODDS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;